import { render, staticRenderFns } from "./PaidMembershipPrice.vue?vue&type=template&id=31c095a8&"
import script from "./PaidMembershipPrice.vue?vue&type=script&lang=ts&"
export * from "./PaidMembershipPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports